window.fbAsyncInit = function () {
    FB.init({
        appId: '235646946927810',
        xfbml: true,
        version: 'v2.5'
    });
};

(function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id))
        return;
    js = d.createElement(s);
    js.id = id;
    js.src = "//connect.facebook.net/fr_CA/sdk.js#xfbml=1&version=v2.4";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
jQuery(function(){

    jQuery(document).on('click', '[data-share=facebook]', function(e){
        e.preventDefault();
        var elem = jQuery(this);
        console.log(elem);
        FB.ui({
          app_id : '235646946927810',
          method: 'feed',
          link: elem.attr('href'),
          picture: elem.data('picture'),
          name: elem.data('name'),
          caption: elem.data('description')
        });
        return false;
    });


});
